module.exports = __webpack_public_path__ + "img/x11.e6ee9397.jpg";